import { array, nullable, number, partial } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

import { VolumetricMeasurableItem } from '../../job/volumetrics/VolumetricMeasurableItem';

export const Type = partial({
	level: array(nullable(VolumetricMeasurableItem)),
	total: VolumetricMeasurableItem,
	uniqueTrussTypes: iotsUtils.makePartialRecordDecoder(
		constants.job.volumetrics.measurableIds,
		number
	),
});
